<template>
  <!-- 消防设施操作员 -->
  <div class="page-container">
    <div class="head">
      <div>移动应用介绍</div>
      <div>
        <!-- <el-button type="primary"
                   @click="onAdd"
                   size="medium">新增</el-button> -->

      </div>
    </div>
    <!--表格内容栏-->
    <el-table :data="tabData"
              border
              style="width: 100%">
      <el-table-column type="index"
                       align="center">
      </el-table-column>
      <el-table-column prop="appLogo"
                       label="AppLogo"
                       align="center">
        <template slot-scope="scope">
          <img
      style="width: 100px; height: 100px"
      :src="scope.row.appLogo"
      ></img>
        </template>
      </el-table-column>
      <el-table-column prop="appName"
                       label="AppName"
                       align="center">
      </el-table-column>
         <el-table-column prop="appDesc"
                       label="AppDesc"
                       align="center">
      </el-table-column>
      <!-- <el-table-column fixed="right"
                       label="操作"
                       align="center"
                       width="200">
        <template slot-scope="scope">
          <el-button size="mini"
                     @click="handleEdit(scope.$index, scope.row)">修改</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <div style="display:flex;justify-content: flex-end;margin-top: 15px;">
      <el-pagination background
                     layout="prev, pager, next"
                     :total="total"
                     :page-size="pamas.pageSize"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
    <!--新增编辑界面-->
    <el-dialog :title="title"
               :visible.sync="dialogVisible"
               width="30%"
               @close="coloseDialog">
      <div>
        <el-form ref="form"
                 :model="form"
                 label-width="100px">
          <el-form-item label="标题">
            <el-input v-model="form.itemName"
                      disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="是否启用">
            <el-radio-group v-model="form.isEnabled">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="价格">
            <el-input v-model="form.price"
                      :rows="4"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="medium">取 消</el-button>
        <el-button type="primary"
                   @click="handleSave"
                   size="medium">更 新</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { format } from "@/utils/datetime"
export default {
  components: {
  },
  data () {
    return {
      filters: {},
      size: "small",
      tabData: [],
      dialogVisible: false,
      title: "更新",
      total: 0,
      form: {
        itemName: "",
        isEnabled: 1,
        price: "",
      },
      pamas: {
        dictItemId: "",
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
  },
  created () {
    this.pamas.dictItemId = this.$route.meta.index
    this.getList()
  },
  methods: {
    pageSizeChangeHandle (val) {
      this.pamas.pageSize = val;
      this.pamas.pageNum = 1;
      this.getList();
    },
    pageCurrentChangeHandle (val) {
      this.pamas.pageNum = val;
      this.getList();
    },
    getList () {
      this.$api.introduce.getListApi(this.pamas).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.tabData = [res.data]
          this.total = res.data.total
        }
      })
    },
    onAdd () {
      this.dialogVisible = true
    },

    handleSave () {
      // if (this.form.id) {
      //   this.handleUpdate()
      //   return
      // }
      this.$api.price.updateApi(this.form).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.$message.success('更新成功')
          this.dialogVisible = false
          this.reasetForm()
          this.getList()
        }
      })
    },
    coloseDialog () {
      this.reasetForm()
    },
    //重置表格
    reasetForm () {
      this.form.itemName = ""
      this.form.price = ""
      this.form.isEnabled = 1
    },

    handleDelete (index, item) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        // 用户点击确认
        this.$api.bananer.deleteApi(item.id).then((res) => {
          if (res.code != 200) {
            this.$message({
              message: res.message,
              type: 'error'
            })
          } else {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      }).catch(() => {
        // 用户点击取消
        console.log('取消操作');
      });

    },
    handleEdit (index, item) {
      console.log(item, 'item')
      this.dialogVisible = true
      this.title = '更新'
      // this.form.dictItemId = this.pamas.dictItemId 
      this.form = JSON.parse(JSON.stringify(item))
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header {
  text-align: left;
}
.head {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/AppIntroduce/AppIntroduce.vue